import { SettingOnboardingTooltip } from '@/fsd/entities/onboarding/ui/settingOnboardingTooltip/settingOnboardingTooltip';
import { ActiveTariffsDaysLeftBlock } from '@/fsd/feature/payments-and-tarrifs/show-active-tarrifs-days-left';
import { ToggleCabinet } from '@/fsd/feature/toggle-cabinet';
import { FaqIcon } from '@/fsd/shared/ui/icons';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUserStore } from '../../../entities/user/model/store/useUserStore';
import SearchBar from '../../../pages/faq/ui/ui/SearchBar/SearchBar.jsx';
import { default as style } from './header.module.scss';
import HeaderNavDefault from './HeaderNavDefault/HeaderNavDefault';
import HeaderNavFaq from './HeaderNavFaq/HeaderNavFaq';
import { LkMenu } from './LkMenu/LkMenu';
import Notifications from './Notifications/Notifications';
import { EnteringInitialDataChecklistButton } from '../../entering-initial-data-checklist/ui/EnteringInitialDataChecklistButton/EnteringInitialDataChecklistButton';
import { ContinueOnboardingButton } from '@/fsd/feature/onboarding/continue-onboarding/ui/ContinueOnboardingButton/ContinueOnboardingButton';

export const Header = observer(({ full }) => {
  const location = useLocation();

  const userStore = useUserStore();

  const [faqSearch, setFaqSearch] = useState(false);

  return (
    <header className={style.header}>
      <SettingOnboardingTooltip />
      <div className={`${style.faqSearch} ${faqSearch ? style.active : ''}`}>
        <SearchBar active={faqSearch} onClose={() => setFaqSearch(false)} />
      </div>
      <div
        className={style['header-nav']}
        style={{ maxWidth: full ? '100vw' : '' }}
      >
        {location.pathname.includes('faq') ? (
          <HeaderNavFaq />
        ) : (
          <HeaderNavDefault />
        )}

        {!userStore.token && (
          <div className={`${style.skeleton} ${style['user-skeleton']}`} />
        )}

        {userStore.token && userStore.isLogged && (
          <div className={cx(style['header-nav__item'], style.relative)}>
            <ContinueOnboardingButton />
            <ActiveTariffsDaysLeftBlock />
            {/* <EnteringInitialDataChecklistButton /> */}
            <ToggleCabinet />
            <Link to="/faq" className={style.faq}>
              <FaqIcon />
            </Link>
            <Notifications />
            {location.pathname.includes('/faq') &&
              location.pathname.length > 5 && (
                <div
                  onClick={() => setFaqSearch(true)}
                  className={style.inputWrap}
                >
                  <svg
                    id={'noClose'}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      id={'noClose'}
                      d="M14.9595 16.256L14.9604 16.256C15.0525 16.2563 15.1436 16.2375 15.2282 16.2008C15.3124 16.1643 15.3883 16.1109 15.4512 16.0439C15.5783 15.9114 15.6491 15.7344 15.6491 15.5505C15.6491 15.3663 15.578 15.189 15.4505 15.0564L15.4505 15.0564L15.4491 15.055L11.1147 10.6652C12.1118 9.50932 12.6473 8.01763 12.6135 6.48165C12.5786 4.89817 11.9413 3.38886 10.8335 2.26759C9.72568 1.14626 8.23258 0.499271 6.66447 0.461605C5.09637 0.423938 3.5745 0.998509 2.41517 2.06542C1.25589 3.13229 0.548326 4.60934 0.439056 6.18937C0.329786 7.7694 0.827171 9.33143 1.82821 10.5508C2.82929 11.7702 4.25714 12.5531 5.81516 12.7362C7.32956 12.9143 8.85316 12.5123 10.0866 11.6128L14.4719 16.0454C14.5351 16.111 14.6106 16.1635 14.694 16.1996L14.7537 16.062L14.694 16.1996C14.7779 16.236 14.8681 16.2551 14.9595 16.256ZM1.71228 6.5394C1.7123 5.58279 1.993 4.64779 2.51869 3.85264C3.04439 3.05748 3.79143 2.43796 4.66515 2.07219C5.53885 1.70643 6.50015 1.61076 7.42756 1.7972C8.35498 1.98364 9.20709 2.44389 9.87604 3.11998C10.545 3.79609 11.0008 4.6577 11.1854 5.59594C11.3701 6.53419 11.2753 7.50669 10.9131 8.3904C10.5509 9.2741 9.93773 10.0291 9.15126 10.5603C8.36485 11.0913 7.44046 11.3747 6.49497 11.3747C5.22739 11.3736 4.01173 10.8641 3.11492 9.95777C2.21806 9.05134 1.71342 7.82196 1.71228 6.5394Z"
                      fill="#8496AF"
                      stroke="#8496AF"
                      strokeWidth="0.3"
                    />
                  </svg>
                  Поиск
                </div>
              )}

            <LkMenu />
          </div>
        )}
      </div>
    </header>
  );
});
